import { SingleResultService } from './../../core/services/single-hotel.service';
import { ResultsService } from './../../core/services/results.service';
import { ResultsContainer } from './results.container';
import { TabHeaderComponent } from './tab-header/tabheader.component';
import { HotelSingleSidebarComponent } from './hotel-single/right-sidebar/hotel-single-sidebar.component';
import { HotelSingleLocationComponent } from './hotel-single/hotel-single-location/hotel-single-location.component';
import { HotelSingleFacilitiesComponent } from './hotel-single/hotel-facilities/hotel-facilities.component';
import { HotelSingleDescriptionComponent } from './hotel-single/hotel-description.component/hotel-desciption.component';
import { HotelSingleInnerComponent } from './hotel-single/hotel-inner-single.component/hotel-inner-single.component';
import { HotelSingleComponent } from './hotel-single/hotel-single.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from './../../shared/components/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SidebarComponent } from './sidebar/sidebar.component';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { ResultsComponent } from './results.component';
import { NouisliderModule } from 'ng2-nouislider';
import { Angulartics2Module } from 'angulartics2';
import { HotelPreviewComponent } from './hotel-preview/hotel-preview.component';
import {ResultsInitComponent} from './results-init.component';
import {ModalModule} from 'ngx-bootstrap/modal';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { OwnerPropertyPreviewComponent } from './propertypreview/propertypreview';

import { YouTubePlayerModule } from '@angular/youtube-player';

import { NgxSpinnerModule } from 'ngx-spinner';

const routes: Routes = [
    { path: 'results', component: ResultsInitComponent, children: [
        { path: 'property/:hotelname/:hotelid', component: HotelSingleComponent }, { path: '', component: ResultsComponent}
      ] },
      { path: 'propertypreview/:hotelid', component: OwnerPropertyPreviewComponent, pathMatch: 'full' }
  ];

@NgModule({
    imports: [
    CommonModule,
      RouterModule.forRoot(routes),
      NgbModule,
      SharedModule,
      FormsModule,
      NgxUsefulSwiperModule,
      NouisliderModule,
      YouTubePlayerModule,
      NgxSpinnerModule,
      Angulartics2Module.forRoot(),
      ModalModule.forRoot()
    ],
    exports: [
        SidebarComponent, RouterModule, ModalModule
    ],
    declarations: [
        ResultsComponent,
        SidebarComponent,
        HotelPreviewComponent,
        HotelSingleComponent,
        HotelSingleInnerComponent,
        HotelSingleDescriptionComponent,
        HotelSingleFacilitiesComponent,
        HotelSingleLocationComponent,
        HotelSingleSidebarComponent,
        TabHeaderComponent,
        ResultsInitComponent,
        OwnerPropertyPreviewComponent
    ],
    providers: [
        ResultsContainer,
        ResultsService,
        SingleResultService
    ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ResultsModule { }
